import React from "react";
//outsource
import { DatePicker } from "antd";
//components
//redux

const formatDate = "DD/MM/YYYY";

const TimeFrom = (props) => {
  // -------------------------- VAR --------------------------
  const { from, setFrom } = props;
  const { to } = props;
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION ------------------------
  const handleChange = (value) => {
    setFrom(value);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <DatePicker
      defaultValue={from}
      disabledDate={(current) => {
        return current && current > to;
      }}
      style={{ width: "100%" }}
      placeholder="From Date"
      format={formatDate}
      disabled={false}
      onChange={value => handleChange (value)}
      allowClear={false}
    />
  );
};

export default TimeFrom;
